
import debounce from "lodash/debounce";
import { defineComponent, nextTick, ref } from "vue";
import { IDanhMucVatTuResponseBase } from "@/core/interfaces/ApiResponses";
import { swalNotification } from "@/core/helpers/utils";
import { usePagination } from "@/core/hooks/use-pagination";
import { useRouterCustom } from "@/core/hooks/use-router-custom";
import { usePageHeader } from "@/core/hooks/usePageHeader";
import { DANH_MUC_VAT_TU } from "@/core/constants/permissions";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import DanhMucVatTuService from "@/core/services/DanhMucVatTu.service";
import DanhMucVatTuTable from "@/views/crafted/pages/danh-muc-vat-tu/danh-muc-vat-tu-table/DanhMucVatTuTable.vue";
import Pagination from "@/components/shared/pagination/Pagination.vue";
import PageContentBase from "@/layout/_shared/PageContentBase.vue";
import PageHeaderActions from "@/layout/header/PageHeaderActions.vue";
import PageHeaderActionItem from "@/layout/header/PageHeaderActionItem.vue";

export default defineComponent({
  name: "danh-muc-vat-tu-danh-sach",

  components: {
    DanhMucVatTuTable,
    PageContentBase,
    PageHeaderActions,
    PageHeaderActionItem,
    Pagination,
  },

  setup() {
    const { push } = useRouterCustom();
    const { currentPage, totalItems, perPage, loading, perPageArr } =
      usePagination();
    const danhMucVatTuItems = ref<IDanhMucVatTuResponseBase[]>([]);
    document.title = "Nhóm vật tư - Đường sắt Hà Nội";

    const { searchQuery } = usePageHeader({
      title: "Danh sách nhóm vật tư",
      breadcrumbs: [{ text: "Nhóm vật tư" }],
      showSearch: true,
      searchPlaceholder: "Nhập từ khóa tìm kiếm",
      addLabel: "Thêm nhóm vật tư",
      addPermissions: [DANH_MUC_VAT_TU.TAO_MOI],
      onAdd: () => push("/quan-ly/danh-muc-vat-tu/tao-moi"),
    });

    return {
      danhMucVatTuItems,
      currentPage,
      totalItems,
      perPage,
      loading,
      perPageArr,
      searchQuery,
      faPrint,
    };
  },

  watch: {
    async currentPage() {
      await this.fetchData();
    },

    async perPage() {
      if (this.currentPage === 1) {
        await this.fetchData();
        return;
      }
      this.currentPage = 1;
    },

    searchQuery: debounce(async function () {
      await nextTick();

      if (this.currentPage === 1) {
        await this.fetchData();
        return;
      }

      this.currentPage = 1;
    }, 700),
  },

  async mounted() {
    await this.fetchData();
  },

  methods: {
    openPrintViewer() {
      const route = this.$router.resolve({
        name: "xem-danh-sach-danh-muc-vat-tu",
        query: this.searchQuery ? { s: this.searchQuery } : {},
      });

      window.open(route.href, "_blank");
    },

    async fetchData() {
      try {
        this.loading = true;

        const {
          data: {
            data: { data: res, total },
          },
        } = await DanhMucVatTuService.list(
          this.currentPage,
          this.perPage,
          this.searchQuery
        );

        this.totalItems = total;
        this.danhMucVatTuItems = res;
        this.loading = false;
      } catch (e) {
        this.loading = false;

        await swalNotification(
          "Có lỗi xảy ra khi lấy danh sách nhóm vật tư",
          "error"
        );
      }
    },
  },
});
